
import { Routes, Route, Navigate, useLocation, useRoutes } from "react-router-dom";

import React, { Suspense } from 'react';
// import { Navigate } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import Login from '../pages/Login/login';
import PasswordForgot from '../pages/PasswordForgot/passwordForgot';
import PasswordReset from '../pages/PasswordReset/passwordReset';
import PasswordResetSuccess from '../pages/PasswordResetSuccess/passwordResetSuccess';

import Homepage from '../pages/Homepage/homePage';
import RouterAuth from '../components/RouterAuth/routerAuth';
import RouterTitle from '../components/RouterTitle/routerTitle';

import PageNotFound from '../components/PageNotFound/pageNotFound';

const Dashboard = React.lazy(() => import('../components/DashboardPage/dashboard'));
const UserManage = React.lazy(() => import('../components/UserManage/userManage'));
const Merchants = React.lazy(() => import('../components/Merchants/merchants'));
// const AdminRole = React.lazy(() => import('../components/AdminRole/adminRole'));
const UserProfile = React.lazy(() => import('../components/UserProfile/userProfile'));
const FrontendUser = React.lazy(() => import('../components/FrontendUser/frontendUser'));
const FrontendUserPrimaryFieldAuth = React.lazy(() => import('../components/FrontendUserPrimaryFieldAuth/frontendUserPrimaryFieldAuth'));
const DeviceToken = React.lazy(() => import('../components/DeviceToken/deviceToken'));
const Notification = React.lazy(() => import('../components/Notification/notification'));


// 实现懒加载的用Suspense包裹 定义函数
const lazyLoad = (children) => {
  return <Suspense fallback={<h1>Loading...</h1>}>
    {children}
  </Suspense>
}


const Routers = props => {

  const { formatMessage } = useIntl();

  const routes = [
    {
      path: '/',
      element: <Navigate to="/dashboard" />,
      auth: false
    },
    {
      path: '/index',
      element: <Navigate to="/dashboard" />,
      auth: false
    },
    {
      path: '/login',
      element: <RouterTitle
        title={formatMessage({ id: 'router.login', defaultMessage: 'Login' })}
      >
        <Login />
      </RouterTitle>,

    },
    {
      path: '/forgetpassword',
      element: <RouterTitle
        title={formatMessage({ id: 'router.forgetpassword', defaultMessage: 'Forget password' })}
      >
        <PasswordForgot />
      </RouterTitle>,

    },
    {
      path: '/resetpassword',
      element: <RouterTitle
        title={formatMessage({ id: 'router.resetpassword', defaultMessage: 'Reset password' })}
      >
        <PasswordReset />
      </RouterTitle>

    },
    {
      path: '/resetpassword/success',
      element: <RouterTitle
        title={formatMessage({ id: 'router.passwordResetSuccess', defaultMessage: 'Reset password success' })}
      >
        <PasswordResetSuccess />
      </RouterTitle>,

    },
    {
      path: '/',
      element: <Homepage />,
      auth: true,
      children: [
        {
          path: "*",
          element: <Navigate to="/page-not-found" />
        },
        {
          path: "/page-not-found",
          element: <RouterAuth
            title={formatMessage({ id: 'router.dashboard', defaultMessage: 'dashboard' })}
            permissionCode="">
            <PageNotFound />
          </RouterAuth>
        },
        {
          path: '/dashboard',
          element: <RouterAuth
            title={formatMessage({ id: 'router.dashboard', defaultMessage: 'dSashboard' })}
            permissionCode="dashboard">
            {lazyLoad(<Dashboard />)}
          </RouterAuth>

        },
        // {
        //   path: '/admin-role',
        //   element: <RouterAuth
        //     title={formatMessage({ id: 'router.adminRole', defaultMessage: 'Admin Role' })}
        //     permissionCode="permission/admin_role/list">
        //     {lazyLoad(<AdminRole />)}
        //   </RouterAuth>

        // },
        {
          path: '/users',
          element: <RouterAuth
            title={formatMessage({ id: 'router.users', defaultMessage: 'Users' })}
            permissionCode="permission/admin_user/list">
            {lazyLoad(<UserManage />)}
          </RouterAuth>
        },
        {
          path: '/user/profile',
          element: <RouterAuth
            title={formatMessage({ id: 'router.merchants', defaultMessage: 'Merchants' })}
            permissionCode="permission/admin_user/list">
            {lazyLoad(<UserProfile />)}
          </RouterAuth>

        },
        {
          path: '/merchants',
          element: <RouterAuth
            title={formatMessage({ id: 'router.merchants', defaultMessage: 'Merchants' })}
            permissionCode="permission/merchant/list">
            {lazyLoad(<Merchants />)}
          </RouterAuth>

        },
        {
          path: '/frontendUser',
          element: <RouterAuth
            title={formatMessage({ id: 'router.frontendUser', defaultMessage: 'Frontend User' })}
            permissionCode="permission/merchant/list">
            {lazyLoad(<FrontendUser />)}
          </RouterAuth>

        },
        {
          path: '/frontend-user-primary-field-auth',
          element: <RouterAuth
            title={formatMessage({ id: 'router.frontendUserPrimaryFieldAuth', defaultMessage: 'Frontend User Primary Field Auth' })}
            permissionCode="permission/merchant/list">
            {lazyLoad(<FrontendUserPrimaryFieldAuth />)}
          </RouterAuth>

        },
        {
          path: '/device-token',
          element: <RouterAuth
            title={formatMessage({ id: 'router.deviceToken', defaultMessage: 'Device Token' })}
            permissionCode="permission/merchant/list">
            {lazyLoad(<DeviceToken />)}
          </RouterAuth>

        },
        {
          path: '/notification',
          element: <RouterAuth
            title={formatMessage({ id: 'router.notification', defaultMessage: 'Notification' })}
            permissionCode="permission/merchant/list">
            {lazyLoad(<Notification />)}
          </RouterAuth>

        },


      ]
    },


  ]


  const elements = useRoutes(routes)

  return elements
}

export default Routers